// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#acesso-negado .v-card {\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n#acesso-negado .v-card h1 {\n  margin-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
